export default __webpack_public_path__ + "static/CentraNo2-MediumItalic-7f055fd4830f0a89fdd682aa69d9b4eb.woff";